import {
  REMINDERS_PAUSED_REASONS,
  type RemindersPausedReason,
} from './reminders-paused-reason.constants';

export interface RemindersPausedReasonInput {
  reminders_paused: boolean;
  reminders_paused_reason?: RemindersPausedReason | null;
}

/** An API older than the reason field only knew the quota pause. */
export function resolveRemindersPausedReason(
  profile: RemindersPausedReasonInput,
): RemindersPausedReason | null {
  if (profile.reminders_paused_reason !== undefined) {
    return profile.reminders_paused_reason;
  }
  return profile.reminders_paused ? REMINDERS_PAUSED_REASONS.quota : null;
}
